/**
 * @file index.tsx
 *
 * Browser entry point for the client app. Optionally starts the MSW mock layer
 * (when the `useMocks` runtime-config flag is set), then mounts the shop {@link AdminApp}
 * into the `#root` element under React StrictMode.
 */

import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { AdminApp } from './admin/AdminApp';
import { AppShell } from './admin/layout/AppShell';
import { startMocks } from './admin/mocks/start-mocks';
import { AuthProvider } from './auth/AuthProvider';
import { LocaleProvider } from './i18n/LocaleProvider';
import { ShopGate } from './shop/ShopGate';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root not found');
}

void startMocks().finally(() => {
  createRoot(container).render(
    <React.StrictMode>
      <LocaleProvider>
        <AuthProvider>
          <AppShell>
            <ShopGate>
              <AdminApp />
            </ShopGate>
          </AppShell>
        </AuthProvider>
      </LocaleProvider>
      <div className="gv-activated">
        <div
          className="gv-toast-container"
          role="region"
          aria-label="Notifications"
          aria-live="polite"
        />
      </div>
    </React.StrictMode>,
  );
});
